import '@vfde-brix/highlight-badge/dist/styles.css';
import '@vfde-brix/tooltip/dist/styles.css';
import { createHighlightBadgeComponent } from '@vfde-brix/highlight-badge';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-highlight-badge', createHighlightBadgeComponent, NO_PATTERN_BUSINESS_LOGIC);
